import styled from "@emotion/styled";

export const ScrollBar = styled.div<{ position: "Top" | "Fixed" | "Bottom" }>(
    {
        position: "absolute",
        bottom: 0,
        zIndex: 501,
        overflowX: "auto",
    },
    props => props.position === "Top" && { top: 170 },
    props =>
        props.position === "Fixed" && {
            position: "fixed",
            bottom: 0,
        }
);
